import { render, staticRenderFns } from "./VideoLanding.vue?vue&type=template&id=db0f77c6&"
import script from "./VideoLanding.vue?vue&type=script&lang=js&"
export * from "./VideoLanding.vue?vue&type=script&lang=js&"
import style0 from "./VideoLanding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports